import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{backgroundColor:"#4d43486a", backdropFilter:"blur(20px)"}}>
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <div className="text-sm-center
              d-none d-sm-block">
                Enabled by <a href="https://temperstack.com" target="_blank" rel="noopener noreferrer">
                <img src="https://prod-temperstack-public-assets.s3.ap-south-1.amazonaws.com/temperstack-logos/temperstack-logo.png" alt="temperstack"
                     height="15"/>
              </a>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
